import {
  Show,
  SimpleShowLayout,
  TextField,
  EmailField,
  BooleanField,
  DateField,
  FunctionField,
  TabbedShowLayout,
  Tab,
  ArrayField,
  Datagrid,
} from "react-admin";
import { Chip, Box, Typography } from "@mui/material";

export const AuthUserShow = () => (
  <Show>
    <TabbedShowLayout>
      <Tab label="Summary">
        <TextField source="id" label="User ID" />
        <EmailField source="email" label="Email" />
        <TextField source="name" label="Name" />
        <TextField source="did" label="DID" />
        <BooleanField source="emailVerified" label="Email Verified" />
        <FunctionField
          label="Roles"
          render={(record: any) => (
            <Box>
              {record.metadata?.roles?.map((role: string) => (
                <Chip key={role} label={role} sx={{ mr: 0.5 }} />
              ))}
            </Box>
          )}
        />
        <DateField source="createdAt" label="Created At" showTime />
        <DateField source="updatedAt" label="Updated At" showTime />
      </Tab>

      <Tab label="Passkeys" path="passkeys">
        <ArrayField source="passkeys">
          <Datagrid bulkActionButtons={false}>
            <TextField source="id" label="ID" />
            <TextField source="credentialId" label="Credential ID" />
            <TextField source="deviceName" label="Device" />
            <DateField source="createdAt" label="Created" showTime />
            <DateField source="lastUsedAt" label="Last Used" showTime />
          </Datagrid>
        </ArrayField>
      </Tab>

      <Tab label="Wallets" path="wallets">
        <ArrayField source="wallets">
          <Datagrid bulkActionButtons={false}>
            <TextField source="id" label="ID" />
            <TextField source="address" label="Address" />
            <TextField source="chain" label="Chain" />
            <DateField source="linkedAt" label="Linked At" showTime />
          </Datagrid>
        </ArrayField>
      </Tab>

      <Tab label="Stats" path="stats">
        <FunctionField
          label="Statistics"
          render={(record: any) => (
            <Box>
              <Typography variant="body1">
                <strong>Active Sessions:</strong>{" "}
                {record.stats?.activeSessions || 0}
              </Typography>
              <Typography variant="body1">
                <strong>Total Passkeys:</strong>{" "}
                {record.stats?.totalPasskeys || 0}
              </Typography>
              <Typography variant="body1">
                <strong>Total Wallets:</strong>{" "}
                {record.stats?.totalWallets || 0}
              </Typography>
            </Box>
          )}
        />
      </Tab>
    </TabbedShowLayout>
  </Show>
);
